export const dashboardIcon = require("../assets/dashboardIcon.svg")
export const patientIcon = require("../assets/patientIcon.svg")
export const taskListIcon = require("../assets/taskListIcon.svg")
export const visitScheduleIcon = require("../assets/visitScheduleIcon.svg")
export const sendNotificationIcon = require("../assets/sendNotificationIcon.svg")
export const communityIcon = require("../assets/communityIcon.svg")
export const calendarIcon = require("../assets/calendar_icon.png")
export const headerSecenodLogo = require("../assets/headerSecenodLogo.svg")
export const closeButton = require("./close.png")
export const language = require("../assets/language.svg")